module.exports = __webpack_public_path__ + "fonts/Manrope-ExtraLight.fc80ad19.ttf";